export const ndbsQuickOrder = {
  ndbsQuickOrder: {
    actions: {
      clearAllEntries: 'Clear all Entries',
      addToCart: 'Add to Cart',
    },
    uploadLimit: 'You can only add up to 25 products at a time.',
  },
};
